module.exports = __webpack_public_path__ + "img/oguri_kimono_salon_JP.2473f3b6.jpg";